import Config from '../../config';

import Collection from '../../collection';
import Model from '../../model/model';

import { fmt, } from '../../utils/date';





const Stats = Collection.extend( {

	responseAt: 'stats',

    model: Model.extend( {

		customParser(payload) {
            return Stats.extendStats( payload );
		}

	} ),

    getUrl() {
        const date = this.options.calendar.getMonth();
        const datePart = fmt( date, 'YYYY-MM' );
        const { timetableId, time, ...otherFilters } = this.filters;

        let url = !timetableId
            ? `timetables/stats/${datePart}?apiVersion=2.0`
            : time 
                ? `timetables/${timetableId}/stats/${datePart}/@/${time.replace( ':', '-' )}?apiVersion=2.0`
                : `timetables/${timetableId}/stats/${datePart}?apiVersion=2.0`;

		for (let name in otherFilters) if (otherFilters.hasOwnProperty( name ))
            if (undefined !== otherFilters[name])
                url = Config.add( url, name, otherFilters[name] );

        return Config.url( url );
    },

}, {

    extendStats(stats) {
        stats.expired = 
            + stats.done_expired + stats.working_expired;

        stats.done =
            + stats.done_expired + stats.done_not_expired;

        stats.working =
            + stats.working_expired + stats.working_not_expired;

        stats.planned = 
            + stats.planned + stats.creating;

        stats.fail =
            + stats.fail + stats.missed;

        return stats;
    }

} );

export default Stats;


// WEBPACK FOOTER //
// ./src/js/collection/schedule/stats.js